// Copyright (c) 2025 Deere & Company

import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAmountOfUseCommentsToDealer = (state, action) =>
    MeasurementReading.update(state, {
        commentsToDealer: {
            $set: action.comments
        }
    });

const updateAmountOfUseInternalDeereComments = (state, action) =>
    MeasurementReading.update(state, {
        internalDeereComments: {
            $set: action.comments
        }
    });

const updateAmountOfUseItemToUpdate = (state, action) =>
    MeasurementReading.update(state, {
        $set: action.item
    });

export default (state = getDefaultState().amountOfUseItemToUpdate, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_COMMENTS_TO_DEALER]: updateAmountOfUseCommentsToDealer,
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_INTERNAL_DEERE_COMMENTS]: updateAmountOfUseInternalDeereComments,
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_ITEM_TO_UPDATE]: updateAmountOfUseItemToUpdate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/amount-of-use-item-to-update.js